
const title = 'Sobre nós'
export default {
  data() {
    return {
      menu: [
        {
          text: 'Home',
          disabled: !1,
          to: '/'
        },
        {
          text: title,
          disabled: !0,
          to: '/clinica'
        }
      ],
      title,
      top: 'src/images/top/sobre-nos.webp'
    }
  },
  computed: {
    site() {
      return site
    },
    height() {
      let size = 150,
        { xs, sm, mdAndUp } = this.$vuetify.breakpoint
      if (xs) size = 150
      else if (sm) size = 170
      else if (mdAndUp) size = 250
      return size
    }
  },
  created() {
    this.url = window.location.href
  }
}
